import logo from "@/assets/logo/Icon.png";

const ApplicationSubmission = () => {
  return (
    <section className="min h-screen bg-[#F8F8F8] py-[84px]">
      <div className="text-center p-8 bg-white rounded-xl w-[627px] border border-[#E5E9EB] mx-auto">
        <div className="p-2 border border-[#D0D5DD] rounded-md inline-block mb-3">
          <img src={logo} className="size-12" alt="" />
        </div>
        <h1 className="font-semibold text-2x leading-[33px] tracking-[-1%]mb-2.5">
          Application Submitted
        </h1>
        <p className="text-[#98A2B3] text-sm leading-[24px] tracking-[-1%]">
          Thank you for completing your application! It will take approximately
          3 days to review your details. If selected, you will receive an email
          with the next steps. Please keep an eye on your inbox for updates.
        </p>
      </div>
    </section>
  );
};

export default ApplicationSubmission;
